import React from 'react';
import { compose } from 'redux';
import { TableRow, TableHead, TableCell } from '@material-ui/core';

import TypeCell from './TypeCell';
import withCategoriesData from '../../hocs/withData/withCategoriesData';

import TableModal from '../../components/LinkToModal/TableModal';

const Selectable = ({ selectable = false, onChange = () => { } }) => {
  if (!selectable) {
    return null;
  }
  const handleOnChange = (event) => onChange(event.target.checked);
  return (
    <TypeCell item={{ type: 'checkbox' }} onClick={handleOnChange} />
  );
};

const TableHeader = (props) => {
  const { categories } = props;
  return (
    <TableHead>
      <TableRow className="info-row">
        <TableCell />
        <TableCell>
          <TableModal>
            Lists the title of category as it is shown on the reverse of the CPCS Competent Operator card. By clicking the down arrow, you can sort the list alphabetically
          </TableModal>
        </TableCell>
        <TableCell>
          <TableModal>
            Lists the internal codes used for each category. By clicking the down arrow, you can sort the list numerically
          </TableModal>
        </TableCell>
        <TableCell>
          <TableModal>
            Lists a group that each category falls in to. By clicking the down arrow, you can sort the list by group description
          </TableModal>
        </TableCell>
      </TableRow>
      <TableRow>
        <Selectable
          selectable={categories.header.row.selectable || false}
          onChange={props.onSelectAllToggle}
        />
        {categories.header.cells.map((item, index) => (
          <TypeCell key={`cell${index}`} item={item} index={index} {...props} />
        ))}
      </TableRow>
    </TableHead>
  );
};
export default compose(withCategoriesData)(TableHeader);
